import React from 'react';
import styles from './Support.module.scss';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';

function Support() {
  const { t } = useTranslation();

  return (
    <div className={styles.support}>
      <span>{t('common.support.text')}&nbsp;</span>
      <a href={'mailto:support@webfolio.com'} target={'_blank'} className={styles.supportLink} rel='noreferrer'>
        {t('common.support.link')}
      </a>
      <LanguageSwitch />
    </div>
  );
}

export default Support;
